<template>
  <FieldBox :title="$t('trade.order-trail1-price-percent-label')">
    <PlusMinusInput
      v-model="trailingPercent"
      :precision="2"
      :min="0"
      :max="999999999"
      :step="0.01"
    />
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import PlusMinusInput from 'com/PlusMinusInput'
import FieldBox from '../FieldBox'

export default {
  components: {
    FieldBox,
    PlusMinusInput
  },
  props: {
    modifyOrder: { type: Boolean },
    modifyOrderOriginal: { type: Object }
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    trailingPercent: {
      get() {
        return this.order.trailingPercent
      },
      set(trailingPercent) {
        this.$store.dispatch('updateTradeOrder', {
          trailingPercent: Number(trailingPercent)
        })
      }
    }
  }
}
</script>
